import { Injectable, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly history: string[] = [];

  constructor (
    private readonly router: Router,
    private readonly nav: NavController,
    private readonly zone: NgZone,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });

    window.addEventListener('popstate', () => {
      this.zone.run(() => {
        this.history.splice(-2);
      });
    });
  }

  canGoBack(): boolean {
    return this.history.length > 1;
  }

  backOrHome() {
    if (this.canGoBack()) {
      this.history.splice(-2);
      this.nav.back();
    } else {
      this.router.navigate(['home']);
    }
  }
}
